import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      {/* Left: form */}
      <div className="flex flex-col justify-center px-6 sm:px-12 lg:px-20 py-12 tcc-dots">
        <Link to="/" className="flex items-center gap-2.5 mb-10 w-fit">
          <div className="h-10 w-10 rounded-2xl bg-primary flex items-center justify-center shadow-sm">
            <GraduationCap className="text-primary-foreground" strokeWidth={1.6} />
          </div>
          <span className="font-heading font-extrabold text-lg text-slate-800">Teacher Command Center</span>
        </Link>
        <div className="max-w-sm w-full">
          <h1 className="font-heading text-3xl font-extrabold text-slate-800">{title}</h1>
          <p className="text-slate-500 mt-2 mb-8">{subtitle}</p>
          {children}
          {footer && <div className="mt-6 text-sm text-slate-500">{footer}</div>}
        </div>
      </div>

      {/* Right: image */}
      <div className="hidden lg:block relative">
        <img
          src="https://images.unsplash.com/photo-1620275765334-4ed948bb4502?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Calm teacher workspace"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-tr from-primary/40 via-primary/10 to-accent/30" />
        <div className="absolute bottom-12 left-12 right-12 bg-white/25 backdrop-blur-md rounded-3xl p-7 border border-white/40">
          <p className="font-heading text-xl font-bold text-white drop-shadow">"Finally, my whole teaching day in one calm place."</p>
          <p className="text-white/90 text-sm mt-2 drop-shadow">Plan, track, draft, and breathe.</p>
        </div>
      </div>
    </div>
  );
}
